export enum LoyaltyProgram {
  StoredValue = 'STORED_VALUE',
}
